import * as React from 'react';
import type { SVGProps } from 'react';
import { memo } from 'react';
const ImageModalBackgroundTileIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={32}
        height={32}
        fill="none"
        viewBox="0 0 32 32"
        className="Icon image-modal-background-tile"
        {...props}
    >
        <path fill="#fff" d="M0 0h32v32H0z" />
        <path fill="#F3F3F4" d="M0 16h16v16H0zM16 0h16v16H16z" />
    </svg>
);
const Memo = memo(ImageModalBackgroundTileIcon);
export default Memo;
